module.exports = "<div class=\"widget-toolbar no-border\">\n\t<div class=\"inline dropdown-hover\">\n\t\t<button class=\"btn btn-minier btn-primary\">\n\t\t\t{{current}}\n\t\t\t<i class=\"ace-icon fa fa-angle-down icon-on-right bigger-110\"></i>\n\t\t</button>\n\t\t<ul class=\"dropdown-menu dropdown-menu-right dropdown-125 dropdown-lighter dropdown-close dropdown-caret\">\n\t\t\t<li *ngFor=\"let action of actions\">\n\t\t\t\t<a (click)=\"onClick(action)\">{{action}}</a>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/widgets/widget/widget-tools.html
// module id = 546
// module chunks = 0